import { createSlice } from '@reduxjs/toolkit';
import { activateUser, createUser, deactivateUser, getAllCertificates, getDashboardOverview, getUsersList, reassignUser } from '../actions/admin';

const initialState = {
    isLoading: false,
    errorMessage: '',
    selectedUser: null,
    showRegistrationModal: false,
    certificates: {
        status: 'all',
        list: []
    },
    users: [],
    roles: [],
    overview: {
        total_users: 0,
        total_certificates: 0,
        pending_certificates: 0,
        approved_certificates: 0,
        disbursed_certificates: 0
    },
    filterQuery: {
        query: '',
        currentPage: 1,
        pageSize: 10,
        field: 'FIRST_NAME',
    },
    sortColumn: {
        path: 'USER_ID',
        order: 'asc'
    },
};

export const slice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.filterQuery.currentPage = action.payload.currentPage;
        },
        setCertificateStatus: (state, action) => {
            state.certificates.status = action.payload;
        },
        setPageSize: (state, action) => {
            state.filterQuery.pageSize = action.payload.pageSize;
        },
        setField: (state, action) => {
            state.filterQuery.field = action.payload.field;
        },
        setQuery: (state, action) => {
            state.filterQuery.query = action.payload.query;
        },
        setSortColumn: (state, action) => {
            state.sortColumn = action.payload;
        },
        setShowRegistrationModal: (state, action) => {
            state.showRegistrationModal = action.payload;
        },
    },
    extraReducers: (builder) => {   
        builder.addCase(getUsersList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.errorMessage = '';
            state.users = action.payload.data;
        })
        .addCase(getUsersList.rejected, (state, action) => {
            state.isLoading = false;

            if (action.payload) state.errorMessage = action.payload.error || action.payload.message;
            else state.errorMessage = action.error.message;
        })
        .addCase(getUsersList.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = '';
        })
        .addCase(deactivateUser.fulfilled, (state) => {
            state.isLoading = false;
            state.errorMessage = '';
        })
        .addCase(deactivateUser.rejected, (state, action) => {
            state.isLoading = false;

            if (action.payload) state.errorMessage = action.payload.error || action.payload.message;
            else state.errorMessage = action.error.message;
        })
        .addCase(deactivateUser.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = '';
        })
        .addCase(activateUser.fulfilled, (state) => {
            state.isLoading = false;
            state.errorMessage = '';
        })
        .addCase(activateUser.rejected, (state, action) => {
            state.isLoading = false;

            if (action.payload) state.errorMessage = action.payload.error || action.payload.message;
            else state.errorMessage = action.error.message;
        })
        .addCase(activateUser.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = '';
        })
        .addCase(getDashboardOverview.fulfilled, (state, action) => {
            state.isLoading = false;
            state.errorMessage = '';
            state.overview = action.payload.data.overview;
            state.roles = action.payload.data.roles;
        })
        .addCase(getDashboardOverview.rejected, (state, action) => {
            state.isLoading = false;

            if (action.payload) state.errorMessage = action.payload.error || action.payload.message;
            else state.errorMessage = action.error.message;
        })
        .addCase(getDashboardOverview.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = '';
        })
        .addCase(reassignUser.fulfilled, (state) => {
            state.isLoading = false;
            state.errorMessage = '';
        })
        .addCase(reassignUser.rejected, (state, action) => {
            state.isLoading = false;

            if (action.payload) state.errorMessage = action.payload.error || action.payload.message;
            else state.errorMessage = action.error.message;
        })
        .addCase(reassignUser.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = '';
        })
        .addCase(createUser.fulfilled, (state) => {
            state.isLoading = false;
            state.errorMessage = '';
        })
        .addCase(createUser.rejected, (state, action) => {
            state.isLoading = false;

            if (action.payload) state.errorMessage = action.payload.error || action.payload.message;
            else state.errorMessage = action.error.message;
        })
        .addCase(createUser.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = '';
        })
        .addCase(getAllCertificates.fulfilled, (state, action) => {
            state.isLoading = false;
            state.errorMessage = '';
            state.certificates.list = action.payload.data;
        })
        .addCase(getAllCertificates.rejected, (state, action) => {
            state.isLoading = false;

            if (action.payload) state.errorMessage = action.payload.error || action.payload.message;
            else state.errorMessage = action.error.message;
        })
        .addCase(getAllCertificates.pending, (state) => {
            state.isLoading = true;
            state.errorMessage = '';
        })
    }
})

export const { setCertificateQuery, setCertificateField, setCertificateStatus, setCurrentPage, setPageSize, setField, setSortColumn, setSelectedUser, setShowRegistrationModal, setQuery } = slice.actions;
export default slice.reducer;